import * as React from 'react';
import { useParams } from 'react-router-dom';

import { FormReviewFlatModeParams } from 'config/routes';
import useLocalStore from 'hooks/useLocalStore';

import FormReviewFlatTableStore from './FormReviewFlatTableStore';

const FormReviewFlatTableStoreContext =
  React.createContext<FormReviewFlatTableStore | null>(null);

export const FormReviewFlatTableStoreProvider = ({
  children,
}: React.PropsWithChildren) => {
  const { id } = useParams<FormReviewFlatModeParams>();

  const urlParams = new URLSearchParams(window.location.search);

  /* Умышленно кастим к undefined, чтобы скипнуть параметр при запросе */
  const rootId = urlParams.get('rootId') ?? undefined;

  const store = useLocalStore(
    () => new FormReviewFlatTableStore({ id: Number(id), rootId }),
    [id, rootId]
  );

  return (
    <FormReviewFlatTableStoreContext.Provider value={store}>
      {children}
    </FormReviewFlatTableStoreContext.Provider>
  );
};

export const useFormReviewFlatTableStore = () => {
  const context = React.useContext(FormReviewFlatTableStoreContext);

  if (!context) {
    throw new Error('FormReviewFlatTableStoreContext is not provided');
  }

  return context;
};
